/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Form, Space, Typography } from 'antd';
import EntryPointSelect from '../../../Forms/Fields/EntryPointSelect';
import { InfoCircleOutlined } from '@ant-design/icons';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Text } = Typography;

const JumpNodeAAForm = ({
  responseIndex,
  canEdit
}) => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Space className="mb-3 mt-1">
        <InfoCircleOutlined className="text-secondary" />
        <Text className="text-secondary">{t('Agent will redirect to the selected Flow or Automated answer')}</Text>
      </Space>

      <Form.Item
        validateTrigger={['onChange', 'onBlur']}
        rules={[
          {
            required: true,
            message: t('Redirect target cannot be blank.')
          }
        ]}
        name={[responseIndex, 'jumpTo']}
      >
        <EntryPointSelect
          size="large"
          className="fs-base"
          disabled={!canEdit || !isEditingPrimaryLanguage}
        />
      </Form.Item>
    </Fragment>
  );
};

JumpNodeAAForm.propTypes = {
  responseIndex: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired
};

export default JumpNodeAAForm;
